import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { 
    fetchTodosDocumentos, 
    eliminarDocumento, 
    subirDocumento, 
    editarPermisosDocumento,
    fetchObtenerDocumento
} from '../../peticiones_API/PeticionesDocumentos';
import { fetchNegociosData, fetchDepartamentosData, fetchPersonasData } from '../../peticiones_API/PeticionesGestionPersonasPersonas';
import Titulo from "../elementos/basicos/Titulo";
import styled from 'styled-components';
import { UsuarioContext } from "../providers/personaContext";
import { 
    Box, 
    Paper,
    TextField,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    CircularProgress,
    Button,
    IconButton,
    Tooltip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Chip,
    Stack,
    tableCellClasses,
    ButtonGroup,
    Menu,
    Checkbox,
    DialogContentText,
    Autocomplete,
    Pagination
} from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import UploadIcon from '@mui/icons-material/Upload';
import DownloadIcon from '@mui/icons-material/Download';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { ToastContainer, toast } from "react-toastify";

const StyledTableCell = muiStyled(TableCell)(({ theme }) => ({
    textAlign: 'center !important',
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'rgba(0, 60, 102, 0.8)',
        color: theme.palette.common.white,
        padding: '10px',
        fontWeight: 'bold',
    },
}));

const StyledTableRow = muiStyled(TableRow)(({ theme }) => ({
    textAlign: 'center !important',
    cursor: 'pointer',
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:nth-of-type(even)': {
        backgroundColor: 'transparent',
    },
    '&:hover': {
        backgroundColor: `${theme.palette.action.hover} !important`,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
    '& td': {
        padding: '4px 10px',
    },
}));

const SortableHeaderCell = muiStyled(StyledTableCell)(({ theme }) => ({
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
        backgroundColor: 'rgba(0, 60, 102, 0.9)',
    },
}));

const TruncatedCell = muiStyled(TableCell)(({ maxWidth = 200 }) => ({
    maxWidth: maxWidth,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
}));

const DragDropZone = muiStyled(Box)(({ theme, isDragging }) => ({
    border: `2px dashed ${isDragging ? '#336385' : theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(4),
    textAlign: 'center',
    backgroundColor: isDragging ? 'rgba(51, 99, 133, 0.05)' : 'transparent',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
        borderColor: '#336385',
        backgroundColor: 'rgba(51, 99, 133, 0.05)',
    },
}));

const GestorDocumentos = () => {
    const { persona } = useContext(UsuarioContext);
    const location = useLocation();
    const navigate = useNavigate();
    const urlPadre = window.location.pathname;


    const params = new URLSearchParams(location.search);
    const registrosPorPagParam = parseInt(params.get("registrosPorPag")) || 10;
    const paginaParam = parseInt(params.get("pagina")) || 1;
    const busquedaParam = params.get("busqueda") || '';
    const usuarioParam = params.get("usuario") || '';
    const empresaParam = params.get("empresa") || '';
    const departamentoParam = params.get("departamento") || '';
    const ordenColumnaParam = params.get("ordenColumna") || '';
    const ordenParam = params.get("orden") || '';
    
    const [loading, setLoading] = useState(true);
    const [loadingDocumentos, setLoadingDocumentos] = useState(false);
    const [documentos, setDocumentos] = useState([]);
    const [meta, setMeta] = useState({});
    const [pagina, setPagina] = useState(paginaParam);
    const [registrosPorPag, setRegistrosPorPag] = useState(registrosPorPagParam);
    const [archivoSubiendo, setArchivoSubiendo] = useState(false);
    
    const [departamentos, setDepartamentos] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    
    const [busqueda, setBusqueda] = useState(busquedaParam);
    const [busquedaTemp, setBusquedaTemp] = useState(busquedaParam);
    
    
    const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(usuarioParam);
    const [empresaSeleccionada, setEmpresaSeleccionada] = useState(empresaParam);
    const [departamentoSeleccionado, setDepartamentoSeleccionado] = useState(departamentoParam);
    
    const [ordenColumna, setOrdenColumna] = useState(ordenColumnaParam);
    const [orden, setOrden] = useState(ordenParam);
    
    
    const [modalSubir, setModalSubir] = useState(false);
    const [archivoSubir, setArchivoSubir] = useState(null);
    const [permisosNuevo, setPermisosNuevo] = useState([]);
    const [previewArchivoNuevo, setPreviewArchivoNuevo] = useState(null);
    const [dragActive, setDragActive] = useState(false);
    const [nombreArchivoNuevo, setNombreArchivoNuevo] = useState('');
    const [errorNombreNuevo, setErrorNombreNuevo] = useState('');
    
    
    const [modalEditar, setModalEditar] = useState(false);
    const [documentoEditar, setDocumentoEditar] = useState(null);
    const [permisosEditar, setPermisosEditar] = useState([]);
    const [nombreDocumentoEditar, setNombreDocumentoEditar] = useState('');
    const [errorNombreEditar, setErrorNombreEditar] = useState('');
    
    
    const [modalPreview, setModalPreview] = useState(false);
    const [documentoPreview, setDocumentoPreview] = useState(null);
    const [urlPreview, setUrlPreview] = useState(null);
    const [cargandoPreview, setCargandoPreview] = useState(false);
    const [errorPreview, setErrorPreview] = useState(false);
    
    const [seleccionados, setSeleccionados] = useState([]);
    const [anchorElAcciones, setAnchorElAcciones] = useState(null);
    const [documentoAccion, setDocumentoAccion] = useState(null);
    
    const [modalConfirmarEliminar, setModalConfirmarEliminar] = useState(false);
    const [documentosAEliminar, setDocumentosAEliminar] = useState([]);
    const [eliminandoDocumentos, setEliminandoDocumentos] = useState(false);
    
    const [recargarDocumentos, setRecargarDocumentos] = useState(0);

        useEffect(() => {
            setSeleccionados([]);
            const tabla = document.querySelector('.MuiTable-root');
            if (tabla) {
                tabla.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, [documentos]);

    useEffect(() => {
        async function cargarMaestros() {
            try {
                if (!persona || !persona.rol) {
                    setLoading(false);
                    return;
                }

                const departamentosResponse = await fetchDepartamentosData();
                const empresasResponse = await fetchNegociosData();
                const personasResponse = await fetchPersonasData();

                
                const departamentosInternos = departamentosResponse.filter(dep => dep.tipo === "interno");
                setDepartamentos(departamentosInternos);
                setEmpresas(empresasResponse);
                
                
                const usuariosArray = personasResponse.map(persona => ({
                    Id: persona.Id,
                    nombre: persona.nombre,
                    apellidos: persona.apellidos
                }));
                setUsuarios(usuariosArray);
                
                setLoading(false);
            } catch (error) {
                console.log("Error al cargar maestros:", error);
                setLoading(false);
            }
        }
        cargarMaestros();
    }, [persona]);

    
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const registrosPorPagURL = parseInt(params.get("registrosPorPag")) || 10;
        setRegistrosPorPag(registrosPorPagURL);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setBusqueda(busquedaTemp);
            setPagina(1);
        }, 200);

        return () => clearTimeout(timer);
    }, [busquedaTemp]);

    
    useEffect(() => {
        const params = new URLSearchParams();
        params.set('pagina', pagina);
        params.set('registrosPorPag', registrosPorPag);
        if (busqueda) params.set('busqueda', busqueda);
        if (usuarioSeleccionado) params.set('usuario', usuarioSeleccionado);
        if (empresaSeleccionada) params.set('empresa', empresaSeleccionada);
        if (departamentoSeleccionado) params.set('departamento', departamentoSeleccionado);
        if (ordenColumna) params.set('ordenColumna', ordenColumna);
        if (orden) params.set('orden', orden);

        navigate(`${urlPadre}?${params.toString()}`, { replace: true });
    }, [pagina, registrosPorPag, busqueda, usuarioSeleccionado, empresaSeleccionada, departamentoSeleccionado, ordenColumna, orden, navigate, urlPadre]);

    
    useEffect(() => {
        let isMounted = true;
        
        async function cargarDocumentos() {
            try {
                if (!persona || !persona.rol) {
                    return;
                }

                const documentosResponse = await fetchTodosDocumentos(
                    pagina,
                    registrosPorPag,
                    busqueda || null,
                    usuarioSeleccionado || null,
                    empresaSeleccionada || null,
                    departamentoSeleccionado || null,
                    ordenColumna,
                    orden
                );

                if (isMounted) {
                    // La respuesta puede ser un array directo o un objeto con data y meta
                    const docsFiltrados = Array.isArray(documentosResponse) 
                        ? documentosResponse 
                        : (documentosResponse.data || []);


                    setDocumentos(docsFiltrados);
                    setMeta(documentosResponse.meta || {});
                    setLoadingDocumentos(false);
                }
            } catch (error) {
                if (isMounted) {
                    console.log("Error al cargar documentos:", error);
                    setLoadingDocumentos(false);
                }
            }
        }
        
        setLoadingDocumentos(true);
        cargarDocumentos();

        return () => {
            isMounted = false;
        };
    }, [persona, pagina, registrosPorPag, busqueda, usuarioSeleccionado, empresaSeleccionada, departamentoSeleccionado, ordenColumna, orden, recargarDocumentos]);

    const handleOrdenar = (columna) => {
        if (ordenColumna === columna) {
            setOrden(orden === 'ASC' ? 'DESC' : 'ASC');
        } else {
            setOrdenColumna(columna);
            setOrden('ASC');
        }
        setPagina(1);
    };

    const renderSortIcon = (columna) => {
        if (ordenColumna !== columna) return null;
        return orden === 'ASC' ? (
            <ArrowUpwardIcon fontSize="small" style={{ marginLeft: 4, verticalAlign: 'middle' }} />
        ) : (
            <ArrowDownwardIcon fontSize="small" style={{ marginLeft: 4, verticalAlign: 'middle' }} />
        );
    };

    // Filtrar empresas según departamento seleccionado
    const empresasFiltradas = departamentoSeleccionado
        ? empresas.filter(emp => {
            const depto = departamentos.find(d => d.Id === parseInt(departamentoSeleccionado));
            return depto && depto.Negocios && depto.Negocios.some(e => e.Id === emp.Id);
        })
        : empresas;

    // Filtrar departamentos según empresa seleccionada y ordenar alfabéticamente
    const departamentosFiltrados = (empresaSeleccionada
        ? departamentos.filter(dep => 
            dep.Negocios && dep.Negocios.some(emp => emp.Id === parseInt(empresaSeleccionada))
        )
        : departamentos
    ).sort((a, b) => a.nombre.localeCompare(b.nombre));

    const formatearTamanio = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    };

    const obtenerNombreArchivo = (ruta) => {
        return ruta.split('/').pop();
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '-';
        return new Date(fecha).toLocaleString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const handleSeleccionarTodo = (event) => {
        if (event.target.checked) {
            setSeleccionados(documentos.map(doc => doc.id));
        } else {
            setSeleccionados([]);
        }
    };

    const handleSeleccionarUno = (id) => {
        setSeleccionados(prev => {
            if (prev.includes(id)) {
                return prev.filter(docId => docId !== id);
            } else {
                return [...prev, id];
            }
        });
    };

    const handleAbrirMenuAcciones = (event, documento) => {
        event.stopPropagation();
        setAnchorElAcciones(event.currentTarget);
        setDocumentoAccion(documento);
    };

    const handleCerrarMenuAcciones = () => {
        setAnchorElAcciones(null);
        setDocumentoAccion(null);
    };

    const handleEditarDesdeMenu = () => {
        if (documentoAccion) {
            handleAbrirModalEditar(documentoAccion);
        }
        handleCerrarMenuAcciones();
    };

    const handleEliminarDesdeMenu = () => {
        if (documentoAccion) {
            setDocumentosAEliminar([documentoAccion.id]);
            setModalConfirmarEliminar(true);
        }
        handleCerrarMenuAcciones();
    };

    const handleEliminarSeleccionados = () => {
        setDocumentosAEliminar(seleccionados);
        setModalConfirmarEliminar(true);
    };

    const handleConfirmarEliminar = async () => {
        setEliminandoDocumentos(true);
        try {
            await eliminarDocumento(documentosAEliminar);
            setModalConfirmarEliminar(false);
            setDocumentosAEliminar([]);
            setSeleccionados([]);
            setPagina(1);
            setRecargarDocumentos(prev => prev + 1);
        } catch (error) {
            console.error('Error al eliminar documentos:', error);
            toast.error('Error al eliminar alguno de los documentos: ' + (error.response?.data?.error || 'Error desconocido'));
        } finally {
            setEliminandoDocumentos(false);
        }
    };

    const handleCancelarEliminar = () => {
        setModalConfirmarEliminar(false);
        setDocumentosAEliminar([]);
    };

    const abrirPreview = async (documento) => {
        setDocumentoPreview(documento);
        setModalPreview(true);
        setErrorPreview(false);
        setUrlPreview(null);

        const tipoArchivo = obtenerTipoArchivo(documento.ruta);
        const tiposNoPrevisualizable = ['other'];

        if (tiposNoPrevisualizable.includes(tipoArchivo)) {
            setCargandoPreview(false);
            return;
        }

        setCargandoPreview(true);

        try {
            const response = await fetchObtenerDocumento(documento.id);
            const blob = response.data;
            const blobUrl = window.URL.createObjectURL(blob);
            setUrlPreview(blobUrl);
            setCargandoPreview(false);
        } catch (error) {
            console.error('Error al cargar preview:', error);
            toast.error('Error al cargar la vista previa');
            setErrorPreview(true);
            setCargandoPreview(false);
        }
    };

    const cerrarModalPreview = () => {
        setModalPreview(false);
        if (urlPreview) {
            window.URL.revokeObjectURL(urlPreview);
        }
        setUrlPreview(null);
        setDocumentoPreview(null);
        setErrorPreview(false);
    };

    const descargarArchivo = async (idDocumento, nombre) => {
        try {
            const response = await fetchObtenerDocumento(idDocumento);
            const blob = response.data;
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = nombre;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Error al descargar el archivo:', error);
            toast.error('Error al descargar el archivo');
        }
    };

    const obtenerTipoArchivo = (nombreArchivo) => {
        const extension = nombreArchivo.split('.').pop().toLowerCase();
        if (['pdf'].includes(extension)) return 'pdf';
        if (['png', 'jpg', 'jpeg', 'gif', 'svg', 'webp'].includes(extension)) return 'image';
        if (['mp4', 'webm', 'mkv'].includes(extension)) return 'video';
        if (['mp3', 'wav', 'wma', 'ogg'].includes(extension)) return 'audio';
        if (['html', 'htm'].includes(extension)) return 'html';
        if (['txt', 'csv', 'json', 'xml'].includes(extension)) return 'text';
        return 'other';
    };

    const handleAbrirModalSubir = () => {
        setModalSubir(true);
        setArchivoSubir(null);
        setPreviewArchivoNuevo(null);
        setPermisosNuevo([{ tipo_id: 'usuario', permitido_id: '', empresa_id: null }]);
        setNombreArchivoNuevo('');
        setErrorNombreNuevo('');
    };

    const handleCerrarModalSubir = () => {
        setModalSubir(false);
        setArchivoSubir(null);
        setPreviewArchivoNuevo(null);
        setPermisosNuevo([]);
        setNombreArchivoNuevo('');
        setErrorNombreNuevo('');
    };

    const handleFileSelect = (file) => {
        if (!file) return;
        
        const extension = file.name.split('.').pop().toLowerCase();
        const extensionesPermitidas = [
            'jpeg', 'jpg', 'png', 'gif', 'webp', 'pdf', 'doc', 'docx', 'ppt', 'pptx', 'odt', 'zip', 'rar', '7z', 'exe', 'webm', 'mp4', 'mkv', 'mp3', 'wav', 'wma', 'ogg'
        ];
        
        if (!extensionesPermitidas.includes(extension)) {
            toast.error(`Tipo de archivo no permitido. Solo se permiten: JPEG, PNG, GIF, PDF, DOC, DOCX, PPT, PPTX, ODT, ZIP, RAR, 7Z, EXE, WEBP, WEBM, MP4, MKV, MP3, WAV, WMA, OGG`);
            return;
        }
        
        setArchivoSubir(file);
        setNombreArchivoNuevo(file.name);
        setErrorNombreNuevo('');
        
        if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(extension)) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewArchivoNuevo({ type: 'image', url: reader.result });
            };
            reader.readAsDataURL(file);
        } else if (extension === 'pdf') {
            const url = URL.createObjectURL(file);
            setPreviewArchivoNuevo({ type: 'pdf', url: url });
        } else if (['mp4', 'webm', 'mkv'].includes(extension)) {
            const url = URL.createObjectURL(file);
            setPreviewArchivoNuevo({ type: 'video', url: url });
        } else if (['mp3', 'wav', 'wma', 'ogg'].includes(extension)) {
            const url = URL.createObjectURL(file);
            setPreviewArchivoNuevo({ type: 'audio', url: url });
        } else if (['txt', 'json', 'xml', 'csv'].includes(extension)) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewArchivoNuevo({ type: 'text', url: reader.result });
            };
            reader.readAsText(file);
        } else {
            setPreviewArchivoNuevo({ type: 'other', url: null });
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleFileSelect(e.dataTransfer.files[0]);
        }
    };

    const handleSubirDocumento = async () => {
        if (!archivoSubir) {
            toast.error('Debes seleccionar un archivo para subir');
            return;
        }

        if (!nombreArchivoNuevo || nombreArchivoNuevo.trim() === '') {
            setErrorNombreNuevo('El nombre del archivo es obligatorio');
            toast.error('El nombre del archivo es obligatorio');
            return;
        }

        if (!nombreArchivoNuevo.includes('.')) {
            setErrorNombreNuevo('El nombre debe incluir la extensión del archivo (ej: documento.pdf)');
            toast.error('El nombre debe incluir la extensión del archivo');
            return;
        }

        // Verificar si ya existe un documento con el mismo nombre
        const nombreExistente = documentos.some(doc => {
            const nombreDoc = doc.ruta.split('/').pop();
            return nombreDoc.toLowerCase() === nombreArchivoNuevo.toLowerCase();
        });

        if (nombreExistente) {
            setErrorNombreNuevo('Ya existe un documento con este nombre');
            toast.error('Ya existe un documento con este nombre');
            return;
        }

        if (permisosNuevo.length === 0 || permisosNuevo.some(p => !p.tipo_id || (p.tipo_id !== 'general' && !p.permitido_id))) {
            toast.error('Debes configurar los permisos válidos');
            return;
        }

            let toastSubida = toast.info('Subiendo documento...', { autoClose: false });
        try {
            setArchivoSubiendo(true);
            const formData = new FormData();
            
            const renamedFile = new File([archivoSubir], nombreArchivoNuevo, { type: archivoSubir.type });
            formData.append('file', renamedFile);
            formData.append('permisos', JSON.stringify(permisosNuevo));
            await subirDocumento(formData);
            toast.success('Documento subido con éxito');
            handleCerrarModalSubir();
            setPagina(1);
            setRecargarDocumentos(prev => prev + 1);
        } catch (error) {
            console.log('Error al subir documento:', error);
            if (error.response?.data && error.response?.data.includes("Solo se permiten archivos de formato"))
                toast.warning('Formato de archivo no permitido');
            else
            toast.error('Error al subir el documento');
        } finally {
            setArchivoSubiendo(false);
            toast.dismiss(toastSubida);
        }
    };

    const handleAbrirModalEditar = (documento, event) => {
        if (event) event.stopPropagation();
        setDocumentoEditar(documento);
        setPermisosEditar(documento.permisos.map(p => ({
            tipo_id: p.tipo_id,
            permitido_id: p.permitido_id,
            empresa_id: p.empresa_id
        })));
        setNombreDocumentoEditar(obtenerNombreArchivo(documento.ruta));
        setErrorNombreEditar('');
        setModalEditar(true);
    };

    const handleCerrarModalEditar = () => {
        setModalEditar(false);
        setDocumentoEditar(null);
        setPermisosEditar([]);
        setNombreDocumentoEditar('');
        setErrorNombreEditar('');
    };

    const handleEliminarDesdeEditar = () => {
        if (documentoEditar) {
            handleCerrarModalEditar();
            setDocumentosAEliminar([documentoEditar.id]);
            setModalConfirmarEliminar(true);
        }
    };

    const handleGuardarPermisos = async () => {
        // Validar nombre del documento
        if (!nombreDocumentoEditar || nombreDocumentoEditar.trim() === '') {
            setErrorNombreEditar('El nombre del documento es obligatorio');
            toast.error('El nombre del documento es obligatorio');
            return;
        }

        if (!nombreDocumentoEditar.includes('.')) {
            setErrorNombreEditar('El nombre debe incluir la extensión del archivo (ej: documento.pdf)');
            toast.error('El nombre debe incluir la extensión del archivo');
            return;
        }

        if (permisosEditar.length === 0 || permisosEditar.some(p => !p.tipo_id || (p.tipo_id !== 'general' && !p.permitido_id))) {
            toast.error('Debes configurar al menos un permiso válido');
            return;
        }

        try {
            await editarPermisosDocumento(documentoEditar.id, permisosEditar, nombreDocumentoEditar);
            handleCerrarModalEditar();
            setRecargarDocumentos(prev => prev + 1);
            toast.success('Documento actualizado correctamente');
        } catch (error) {
            console.error('Error al editar documento:', error);
            toast.error('Error al editar el documento: ' + (error.response?.data?.error || 'Error desconocido'));
        }
    };

    const agregarPermiso = (esEdicion = false) => {
        const nuevoPermiso = { tipo_id: 'usuario', permitido_id: '', empresa_id: null };
        if (esEdicion) {
            setPermisosEditar([...permisosEditar, nuevoPermiso]);
        } else {
            setPermisosNuevo([...permisosNuevo, nuevoPermiso]);
        }
    };

    const eliminarPermiso = (index, esEdicion = false) => {
        if (esEdicion) {
            setPermisosEditar(permisosEditar.filter((_, i) => i !== index));
        } else {
            setPermisosNuevo(permisosNuevo.filter((_, i) => i !== index));
        }
    };

    const actualizarPermiso = (index, campo, valor, esEdicion = false) => {
        const permisos = esEdicion ? [...permisosEditar] : [...permisosNuevo];
        permisos[index][campo] = valor;
        
        // Si cambia el tipo, resetear permitido_id y empresa_id
        if (campo === 'tipo_id') {
            if (valor === 'general') {
                permisos[index].permitido_id = 0;
            } else {
                permisos[index].permitido_id = '';
            }
            permisos[index].empresa_id = null;
        }
        
        if (esEdicion) {
            setPermisosEditar(permisos);
        } else {
            setPermisosNuevo(permisos);
        }
    };

    const renderFormularioPermisos = (permisos, esEdicion = false) => {
        return (
            <Box>
                {permisos.map((permiso, index) => (
                    <Box key={index} mb={2} p={2} border="1px solid #ddd" borderRadius={2}>
                        <Stack direction="row" spacing={2} alignItems="center">
                            <FormControl sx={{ minWidth: 150 }}>
                                <InputLabel>Tipo</InputLabel>
                                <Select
                                    value={permiso.tipo_id}
                                    label="Tipo"
                                    onChange={(e) => actualizarPermiso(index, 'tipo_id', e.target.value, esEdicion)}
                                >
                                    <MenuItem value="usuario">Usuario</MenuItem>
                                    <MenuItem value="empresa">Negocio</MenuItem>{/*Hace falta la etiqueta "empresa" ???? del Menu Item */}
                                    <MenuItem value="departamento">Departamento</MenuItem>
                                    <MenuItem value="general">General</MenuItem>
                                </Select>
                            </FormControl>

                            {permiso.tipo_id === 'usuario' && (
                                <Autocomplete
                                    sx={{ flex: 1 }}
                                    options={usuarios}
                                    getOptionLabel={(option) => `${option.nombre} ${option.apellidos}`}
                                    value={usuarios.find(u => u.Id === permiso.permitido_id) || null}
                                    onChange={(event, newValue) => {
                                        actualizarPermiso(index, 'permitido_id', newValue ? newValue.Id : '', esEdicion);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Usuario" variant="outlined" />
                                    )}
                                    isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                    noOptionsText="No se encontraron usuarios"
                                />
                            )}

                            {permiso.tipo_id === 'empresa' && (
                                <FormControl sx={{ flex: 1 }}>
                                    <InputLabel>Negocio</InputLabel>
                                    <Select
                                        value={permiso.permitido_id}
                                        label="Negocio"
                                        onChange={(e) => actualizarPermiso(index, 'permitido_id', e.target.value, esEdicion)}
                                    >
                                        {empresas.map(emp => (
                                            <MenuItem key={emp.Id} value={emp.Id}>
                                                {emp.nombre}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            )}

                            {permiso.tipo_id === 'departamento' && (
                                <>
                                    <FormControl sx={{ flex: 1 }}>
                                        <InputLabel>Departamento</InputLabel>
                                        <Select
                                            value={permiso.permitido_id}
                                            label="Departamento"
                                            onChange={(e) => actualizarPermiso(index, 'permitido_id', e.target.value, esEdicion)}
                                        >
                                            {(permiso.empresa_id ? 
                                                departamentos.filter(dep => 
                                                    dep.Negocios && dep.Negocios.some(emp => emp.Id === parseInt(permiso.empresa_id))
                                                )
                                                :
                                                departamentos
                                            )
                                            .sort((a, b) => a.nombre.localeCompare(b.nombre))
                                            .map(dep => (
                                                <MenuItem key={dep.Id} value={dep.Id}>
                                                    {dep.nombre}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <FormControl sx={{ flex: 1 }}>
                                        <InputLabel>Negocio (opcional)</InputLabel>
                                        <Select
                                            value={permiso.empresa_id || ''}
                                            label="Negocio (opcional)"
                                            onChange={(e) => {
                                                const nuevaEmpresaId = e.target.value || null;
                                                actualizarPermiso(index, 'empresa_id', nuevaEmpresaId, esEdicion);
                                                if (permiso.permitido_id) {
                                                    const deptoActual = departamentos.find(d => d.Id === parseInt(permiso.permitido_id));
                                                    if (nuevaEmpresaId && deptoActual) {
                                                        const perteneceAEmpresa = deptoActual.Negocios && deptoActual.Negocios.some(e => e.Id === parseInt(nuevaEmpresaId));
                                                        if (!perteneceAEmpresa) {
                                                            actualizarPermiso(index, 'permitido_id', '', esEdicion);
                                                        }
                                                    }
                                                }
                                            }}
                                        >
                                            <MenuItem value="">Todas</MenuItem>
                                            {empresas.map(emp => (
                                                <MenuItem key={emp.Id} value={emp.Id}>
                                                    {emp.nombre}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </>
                            )}

                            {permiso.tipo_id === 'general' && (
                                <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                                    <Typography variant="body2" color="text.secondary">
                                        Accesible para todos los usuarios
                                    </Typography>
                                </Box>
                            )}

                            <IconButton 
                                color="error" 
                                onClick={() => eliminarPermiso(index, esEdicion)}
                                disabled={permisos.length === 1}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Stack>
                    </Box>
                ))}
                <Button 
                    startIcon={<AddIcon />} 
                    onClick={() => agregarPermiso(esEdicion)}
                    variant="contained"
                    sx={{ backgroundColor: '#336385', '&:hover': { backgroundColor: '#1f4b72' } }}
                >
                    Agregar Permiso
                </Button>
            </Box>
        );
    };

    const renderPermisos = (permisos) => {
        const maxVisible = 2;
        const permisosVisibles = permisos.slice(0, maxVisible);
        const permisosRestantes = permisos.length - maxVisible;

        return (
            <Box display="flex" flexWrap="wrap" gap={0.5}>
                {permisosVisibles.map((permiso, index) => {
                    let texto = '';
                    let icono = '';
                    
                    if (permiso.tipo_id === 'usuario') {
                        const usuario = usuarios.find(u => u.Id === permiso.permitido_id);
                        icono = '👤';
                        texto = usuario ? `${usuario.nombre.substring(0, 1)}. ${usuario.apellidos.split(' ')[0]}` : `ID:${permiso.permitido_id}`;
                    } else if (permiso.tipo_id === 'empresa') {
                        const empresa = empresas.find(e => e.Id === permiso.permitido_id);
                        icono = '🏢';
                        texto = empresa ? empresa.nombre.substring(0, 12) : `ID:${permiso.permitido_id}`;
                    } else if (permiso.tipo_id === 'departamento') {
                        const departamento = departamentos.find(d => d.Id === permiso.permitido_id);
                        icono = '📁';
                        texto = departamento ? departamento.nombre.substring(0, 10) : `ID:${permiso.permitido_id}`;
                    } else if (permiso.tipo_id === 'general') {
                        icono = '🌐';
                        texto = 'General';
                    }
                    
                    return (
                        <Chip 
                            key={index}
                            label={`${icono} ${texto}`}
                            size="small"
                            sx={{ 
                                height: '20px',
                                fontSize: '0.7rem',
                                '& .MuiChip-label': { px: 1, py: 0 }
                            }}
                        />
                    );
                })}
                {permisosRestantes > 0 && (
                    <Chip 
                        label={`+${permisosRestantes}`}
                        size="small"
                        //color="primary"
                        sx={{ 
                            height: '20px',
                            fontSize: '0.7rem',
                            '& .MuiChip-label': { px: 1, py: 0 },
                            backgroundColor: '#336385',
                            color: 'white',
                        }}
                    />
                )}
            </Box>
        );
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                <CircularProgress />
            </Box>
        );
    }

    return ( 
        <>
            <ToastContainer />
            <CabeceraForm>
                <Titulo
                    texto="GESTIÓN DE DOCUMENTOS"
                    tituloTabla="true"
                />
            </CabeceraForm>

            <ContainerPrincipal>
                <Paper elevation={3} sx={{ width: '98%' }}>
                    <Box p={3}>
                        <Box mb={3} display="flex" gap={2} flexWrap="wrap" alignItems="center">
                            <TextField
                                sx={{ flex: 1, minWidth: 200 }}
                                label="Buscar documento"
                                variant="outlined"
                                value={busquedaTemp}
                                onChange={(e) => setBusquedaTemp(e.target.value)}
                                placeholder="Buscar por nombre de archivo, creador o editor..."
                            />
                            <FormControl sx={{ minWidth: 180 }}>
                                <InputLabel>Negocio</InputLabel>
                                <Select
                                    value={empresaSeleccionada}
                                    label="Negocio" //Antes estaba "Empresa"
                                    onChange={(e) => {
                                        setEmpresaSeleccionada(e.target.value);
                                        setUsuarioSeleccionado('');
                                        if (!departamentoSeleccionado) {
                                            setDepartamentoSeleccionado('');
                                        }
                                        setPagina(1);
                                    }}
                                >
                                    <MenuItem value="">Todas</MenuItem>
                                    {empresasFiltradas.map(emp => (
                                        <MenuItem key={emp.Id} value={emp.Id}>
                                            {emp.nombre}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl sx={{ minWidth: 180 }}>
                                <InputLabel>Departamento</InputLabel>
                                <Select
                                    value={departamentoSeleccionado}
                                    label="Departamento"
                                    onChange={(e) => {
                                        setDepartamentoSeleccionado(e.target.value);
                                        setUsuarioSeleccionado('');
                                        setPagina(1);
                                    }}
                                >
                                    <MenuItem value="">Todos</MenuItem>
                                    {departamentosFiltrados.map(dep => (
                                        <MenuItem key={dep.Id} value={dep.Id}>
                                            {dep.nombre}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <Autocomplete
                                sx={{ minWidth: 180 }}
                                options={usuarios}
                                getOptionLabel={(option) => `${option.nombre} ${option.apellidos}`}
                                value={usuarios.find(u => u.Id === parseInt(usuarioSeleccionado)) || null}
                                onChange={(event, newValue) => {
                                    setUsuarioSeleccionado(newValue ? newValue.Id : '');
                                    setEmpresaSeleccionada('');
                                    setDepartamentoSeleccionado('');
                                    setPagina(1);
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Usuario" variant="outlined" />
                                )}
                                isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                noOptionsText="No se encontraron usuarios"
                            />
                            <Button
                                variant="contained"
                                sx={{ backgroundColor: '#336385', '&:hover': { backgroundColor: '#1f4b72' } }}
                                startIcon={<UploadIcon />}
                                onClick={handleAbrirModalSubir}
                            >
                                Subir Documento
                            </Button>
                            {seleccionados.length > 0 && (
                                <Button
                                    variant="contained"
                                    color="error"
                                    startIcon={<DeleteIcon />}
                                    onClick={handleEliminarSeleccionados}
                                >
                                    Eliminar Seleccionados ({seleccionados.length})
                                </Button>
                            )}
                        </Box>

                        <Box position="relative">
                            {loadingDocumentos && (
                                <Box
                                    position="absolute"
                                    top={0}
                                    left={0}
                                    right={0}
                                    bottom={0}
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    bgcolor="rgba(255, 255, 255, 0.7)"
                                    zIndex={10}
                                >
                                    <CircularProgress size={40} />
                                </Box>
                            )}
                            <Box style={{ opacity: loadingDocumentos ? 0.5 : 1, transition: 'opacity 0.3s' }}>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <StyledTableRow>
                                                <StyledTableCell style={{ width: 50 }}>
                                                    <Checkbox
                                                        checked={seleccionados.length > 0 && seleccionados.length === documentos.length}
                                                        indeterminate={seleccionados.length > 0 && seleccionados.length < documentos.length}
                                                        onChange={handleSeleccionarTodo}
                                                        sx={{ color: 'white', '&.Mui-checked': { color: 'white' }, '&.MuiCheckbox-indeterminate': { color: 'white' } }}
                                                    />
                                                </StyledTableCell>
                                                <SortableHeaderCell 
                                                    align="left" 
                                                    style={{ maxWidth: 300 }}
                                                    onClick={() => handleOrdenar('ruta')}
                                                >
                                                    Nombre del Archivo
                                                    {renderSortIcon('ruta')}
                                                </SortableHeaderCell>
                                                <SortableHeaderCell 
                                                    style={{ maxWidth: 150 }}
                                                    onClick={() => handleOrdenar('creador_nombre')}
                                                >
                                                    Creador
                                                    {renderSortIcon('creador_nombre')}
                                                </SortableHeaderCell>
                                                <SortableHeaderCell 
                                                    style={{ maxWidth: 150 }}
                                                    onClick={() => handleOrdenar('editor_nombre')}
                                                >
                                                    Editor
                                                    {renderSortIcon('editor_nombre')}
                                                </SortableHeaderCell>
                                                <SortableHeaderCell 
                                                    style={{ maxWidth: 100 }}
                                                    onClick={() => handleOrdenar('tamaño')}
                                                >
                                                    Tamaño
                                                    {renderSortIcon('tamaño')}
                                                </SortableHeaderCell>
                                                <StyledTableCell style={{ maxWidth: 200 }}>Permisos</StyledTableCell>
                                                <SortableHeaderCell 
                                                    style={{ maxWidth: 150 }}
                                                    onClick={() => handleOrdenar('createdAt')}
                                                >
                                                    Fecha Creación
                                                    {renderSortIcon('createdAt')}
                                                </SortableHeaderCell>
                                                <SortableHeaderCell 
                                                    style={{ maxWidth: 150 }}
                                                    onClick={() => handleOrdenar('updatedAt')}
                                                >
                                                    Fecha Edición
                                                    {renderSortIcon('updatedAt')}
                                                </SortableHeaderCell>
                                                <StyledTableCell style={{ maxWidth: 120 }}>Acciones</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {documentos.length === 0 ? (
                                                <StyledTableRow>
                                                    <TableCell colSpan={9} align="center">
                                                        <Typography variant="body2" color="textSecondary" style={{ padding: '20px' }}>
                                                            No se encontraron documentos
                                                        </Typography>
                                                    </TableCell>
                                                </StyledTableRow>
                                            ) : (
                                                documentos.map((doc) => {
                                                    const nombreArchivo = obtenerNombreArchivo(doc.ruta);
                                                    const creador = `${doc.creador.nombre} ${doc.creador.apellidos}`;
                                                    const editor = `${doc.editor.nombre} ${doc.editor.apellidos}`;
                                                    const editadoPorOtro = doc.creador_id !== doc.editado_id;
                                                    const fechaEditadaDiferente = new Date(doc.createdAt).getTime() !== new Date(doc.updatedAt).getTime();
                                                    const mostrarEdicion = editadoPorOtro || fechaEditadaDiferente;
                                                    const estaSeleccionado = seleccionados.includes(doc.id);

                                                    return (
                                                        <StyledTableRow key={doc.id} onClick={() => abrirPreview(doc)}>
                                                            <TableCell onClick={(e) => e.stopPropagation()}>
                                                                <Checkbox
                                                                    checked={estaSeleccionado}
                                                                    onChange={() => handleSeleccionarUno(doc.id)}
                                                                />
                                                            </TableCell>
                                                            <Tooltip title={nombreArchivo} arrow>
                                                                <TruncatedCell align="left" maxWidth={300}>
                                                                    {nombreArchivo}
                                                                </TruncatedCell>
                                                            </Tooltip>
                                                            <Tooltip title={creador} arrow>
                                                                <TruncatedCell maxWidth={150}>
                                                                    {creador}
                                                                </TruncatedCell>
                                                            </Tooltip>
                                                            <TruncatedCell maxWidth={150}>
                                                                {mostrarEdicion ? (
                                                                    <Tooltip title={editor} arrow>
                                                                        <span>{editor}</span>
                                                                    </Tooltip>
                                                                ) : '-'}
                                                            </TruncatedCell>
                                                            <TableCell>{formatearTamanio(doc.tamaño)}</TableCell>
                                                            <TableCell>
                                                                {renderPermisos(doc.permisos)}
                                                            </TableCell>
                                                            <TableCell>{formatearFecha(doc.createdAt)}</TableCell>
                                                            <TableCell>
                                                                {mostrarEdicion ? formatearFecha(doc.updatedAt) : '-'}
                                                            </TableCell>
                                                            <TableCell onClick={(e) => e.stopPropagation()}>
                                                                <ButtonGroup variant="contained" size="small">
                                                                    <Button
                                                                        sx={{ backgroundColor: '#336385', '&:hover': { backgroundColor: '#1f4b72' } }}
                                                                        startIcon={<EditIcon />}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleAbrirModalEditar(doc);
                                                                        }}
                                                                    >
                                                                    </Button>
                                                                    <Button
                                                                        sx={{ backgroundColor: '#336385', '&:hover': { backgroundColor: '#1f4b72' } }}
                                                                        size="small"
                                                                        onClick={(e) => handleAbrirMenuAcciones(e, doc)}
                                                                    >
                                                                        <ArrowDropDownIcon />
                                                                    </Button>
                                                                </ButtonGroup>
                                                            </TableCell>
                                                        </StyledTableRow>
                                                    );
                                                })
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                {documentos.length > 0 && meta.totalPages && (
                                    <Box display="flex" justifyContent="space-between" alignItems="center" p={2}>
                                        <Stack spacing={2} sx={{ alignItems: 'center' }}>
                                            <Pagination
                                                count={meta.totalPages || 1}
                                                page={pagina}
                                                onChange={(event, value) => setPagina(value)}
                                                shape="rounded"
                                                boundaryCount={1}
                                                siblingCount={0}
                                                sx={{
                                                    '& .MuiPaginationItem-root.Mui-selected': {
                                                        backgroundColor: '#336385',
                                                        color: '#fff',
                                                        '&:hover': {
                                                            backgroundColor: '#2a5270',
                                                        }
                                                    }
                                                }}
                                            />
                                        </Stack>
                                        <FormControl sx={{ minWidth: 120 }}>
                                            <InputLabel>Registros/Página</InputLabel>
                                            <Select
                                                value={registrosPorPag}
                                                label="Registros/Página"
                                                onChange={(e) => {
                                                    setRegistrosPorPag(e.target.value);
                                                    setPagina(1);
                                                }}
                                            >
                                                <MenuItem value={10}>10</MenuItem>
                                                <MenuItem value={20}>20</MenuItem>
                                                <MenuItem value={50}>50</MenuItem>
                                                <MenuItem value={100}>100</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>
                </Paper>
            </ContainerPrincipal>

            {/* Modal Subir Documento */}
            <Dialog open={modalSubir} onClose={handleCerrarModalSubir} maxWidth="lg" fullWidth>
                <DialogTitle>
                    Subir Nuevo Documento
                    <IconButton
                        onClick={handleCerrarModalSubir}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Box display="flex" gap={3} flexDirection={{ xs: 'column', md: 'row' }}>
                        <Box flex={1}>
                            <Box mb={3}>
                                <DragDropZone
                                    isDragging={dragActive}
                                    onDragOver={handleDragOver}
                                    onDragLeave={handleDragLeave}
                                    onDrop={handleDrop}
                                    onClick={() => document.getElementById('file-input-upload').click()}
                                >
                                    <input
                                        id="file-input-upload"
                                        type="file"
                                        hidden
                                        accept=".jpeg,.jpg,.png,.gif,.webp,.pdf,.doc,.docx,.ppt,.pptx,.odt,.zip,.rar,.7z,.exe,.webm,.mp4,.mkv,.mp3,.wav,.wma,.ogg"
                                        onChange={(e) => handleFileSelect(e.target.files[0])}
                                    />
                                    <CloudUploadIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
                                    <Typography variant="h6" gutterBottom>
                                        {archivoSubir ? archivoSubir.name : 'Arrastra y suelta un archivo aquí'}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        o haz clic para seleccionar
                                    </Typography>
                                    {archivoSubir && (
                                        <Chip
                                            label={`${(archivoSubir.size / 1024).toFixed(2)} KB`}
                                            size="small"
                                            sx={{ mt: 2 }}
                                        />
                                    )}
                                </DragDropZone>
                            </Box>
                            
                            {archivoSubir && (
                                <Box mb={3}>
                                    <TextField
                                        label="Nombre del archivo"
                                        value={nombreArchivoNuevo}
                                        onChange={(e) => {
                                            setNombreArchivoNuevo(e.target.value);
                                            setErrorNombreNuevo('');
                                        }}
                                        error={!!errorNombreNuevo}
                                        helperText={errorNombreNuevo || 'Debe incluir la extensión (ej: documento.pdf)'}
                                        required
                                        fullWidth
                                    />
                                </Box>
                            )}
                            
                            <Typography variant="h6" mb={2}>Permisos</Typography>
                            {renderFormularioPermisos(permisosNuevo, false)}
                        </Box>

                        {/* Columna derecha: Preview */}
                        {previewArchivoNuevo && (
                            <Box 
                                flex={1} 
                                sx={{ 
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 1,
                                    p: 2,
                                    maxHeight: '600px',
                                    overflow: 'auto'
                                }}
                            >
                                <Box display="flex" alignItems="center" gap={1} mb={2}>
                                    <VisibilityIcon color="primary" />
                                    <Typography variant="h6">Vista Previa</Typography>
                                </Box>
                                
                                {previewArchivoNuevo.type === 'image' && (
                                    <Box display="flex" justifyContent="center" alignItems="center">
                                        <img
                                            src={previewArchivoNuevo.url}
                                            alt="Preview"
                                            style={{ maxWidth: '100%', maxHeight: '500px', objectFit: 'contain' }}
                                        />
                                    </Box>
                                )}

                                {previewArchivoNuevo.type === 'video' && (
                                    <Box display="flex" justifyContent="center" alignItems="center">
                                        <video
                                            src={previewArchivoNuevo.url}
                                            controls
                                            style={{ maxWidth: '100%', maxHeight: '70vh' }}
                                        />
                                    </Box>
                                )}
                                {previewArchivoNuevo.type === 'audio' && (
                                    <Box display="flex" justifyContent="center" alignItems="center">
                                        <audio
                                            src={previewArchivoNuevo.url}
                                            controls
                                            style={{ width: '100%' }}
                                        />
                                    </Box>
                                )}

                                {previewArchivoNuevo.type === 'pdf' && (
                                    <object
                                        data={previewArchivoNuevo.url}
                                        type="application/pdf"
                                        style={{ width: '100%', height: '500px', border: 'none' }}
                                    >
                                        <embed
                                            src={previewArchivoNuevo.url}
                                            type="application/pdf"
                                            style={{ width: '100%', height: '500px', border: 'none' }}
                                        />
                                    </object>
                                )}
                                
                                {previewArchivoNuevo.type === 'text' && (
                                    <Box 
                                        component="pre" 
                                        sx={{ 
                                            whiteSpace: 'pre-wrap',
                                            wordBreak: 'break-word',
                                            fontFamily: 'monospace',
                                            fontSize: '0.875rem',
                                            backgroundColor: 'grey.100',
                                            p: 2,
                                            borderRadius: 1,
                                            maxHeight: '500px',
                                            overflow: 'auto'
                                        }}
                                    >
                                        {previewArchivoNuevo.url}
                                    </Box>
                                )}
                                
                                {previewArchivoNuevo.type === 'other' && (
                                    <Box 
                                        display="flex" 
                                        flexDirection="column" 
                                        alignItems="center" 
                                        justifyContent="center"
                                        minHeight="200px"
                                    >
                                        <Typography variant="body1" color="text.secondary" gutterBottom>
                                            No hay vista previa disponible para este tipo de archivo
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {archivoSubir?.name}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCerrarModalSubir} color="error" >Cancelar</Button>
                    <Button onClick={handleSubirDocumento} variant="contained" color="primary" sx={{ backgroundColor: '#336385', '&:hover': { backgroundColor: '#1f4b72' } } } disabled={archivoSubiendo}>
                        Subir
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Modal Editar Permisos */}
            <Dialog open={modalEditar} onClose={handleCerrarModalEditar} maxWidth="md" fullWidth>
                <DialogTitle>
                    Editar Permisos
                    <IconButton
                        onClick={handleCerrarModalEditar}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {documentoEditar && (
                        <>
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                <TextField
                                    label="Nombre del documento"
                                    value={nombreDocumentoEditar}
                                    onChange={(e) => {
                                        setNombreDocumentoEditar(e.target.value);
                                        setErrorNombreEditar('');
                                    }}
                                    error={!!errorNombreEditar}
                                    helperText={errorNombreEditar || 'Debe incluir la extensión (ej: documento.pdf)'}
                                    required
                                    fullWidth
                                    sx={{ flex: 1, mr: 2 }}
                                />
                                <Button
                                    variant="contained"
                                    startIcon={<VisibilityIcon />}
                                    onClick={() => abrirPreview(documentoEditar)}
                                    size="small"
                                    sx={{ backgroundColor: '#336385', '&:hover': { backgroundColor: '#1f4b72' } }}
                                >
                                    vista previa
                                </Button>
                            </Box>
                            <Typography variant="h6" mb={2}>Permisos</Typography>
                            {renderFormularioPermisos(permisosEditar, true)}
                        </>
                    )}
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'space-between' }}>
                    <Button 
                        onClick={handleEliminarDesdeEditar} 
                        color="error" 
                        variant="contained"
                        startIcon={<DeleteIcon />}
                    >
                        Eliminar Documento
                    </Button>
                    <Box>
                        <Button onClick={handleCerrarModalEditar} color="error">Cancelar</Button>
                        <Button onClick={handleGuardarPermisos} variant="contained" color="primary" sx={{ backgroundColor: '#336385', '&:hover': { backgroundColor: '#1f4b72' }, marginLeft: 2 }}>
                            Guardar
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>

            {/* Modal de Preview */}
            <Dialog
                open={modalPreview}
                onClose={cerrarModalPreview}
                maxWidth="xl"
                fullWidth
                PaperProps={{
                    sx: { 
                        height: '95vh'
                    }
                }}
            >
                <DialogTitle>
                    <b>Vista previa:</b> {documentoPreview ? obtenerNombreArchivo(documentoPreview.ruta) : ''}
                </DialogTitle>
                <DialogContent dividers>
                    {cargandoPreview ? (
                        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                            <CircularProgress />
                        </Box>
                    ) : errorPreview ? (
                        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                            <Typography color="error">{errorPreview}</Typography>
                        </Box>
                    ) : !urlPreview && documentoPreview ? (
                        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                            <Typography variant="body1" color="text.secondary">
                                No hay vista previa disponible para este tipo de archivo. Puedes descargarlo usando el botón de abajo.
                            </Typography>
                        </Box>
                    ) : documentoPreview && urlPreview ? (
                        (() => {
                            const tipo = obtenerTipoArchivo(documentoPreview.ruta);
                            if (tipo === 'pdf') {
                                return (
                                    <object
                                        data={urlPreview}
                                        type="application/pdf"
                                        style={{ width: '100%', height: '100%', border: 'none', minHeight: '600px' }}
                                    >
                                        <embed
                                            src={urlPreview}
                                            type="application/pdf"
                                            style={{ width: '100%', height: '100%', border: 'none', minHeight: '600px' }}
                                        />
                                    </object>
                                );
                            } else if (tipo === 'image') {
                                return (
                                    <Box display="flex" justifyContent="center" alignItems="center">
                                        <img
                                            src={urlPreview}
                                            alt="Vista previa"
                                            style={{ maxWidth: '100%', maxHeight: '70vh' }}
                                        />
                                    </Box>
                                );
                            } else if (tipo === 'video') {
                                return (
                                    <Box display="flex" justifyContent="center" alignItems="center">
                                        <video
                                            src={urlPreview}
                                            controls
                                            style={{ maxWidth: '100%', maxHeight: '70vh' }}
                                        />
                                    </Box>
                                );
                            } else if (tipo === 'audio') {
                                return (
                                    <Box display="flex" justifyContent="center" alignItems="center">
                                        <audio
                                            src={urlPreview}
                                            controls
                                            style={{ width: '100%' }}
                                        />
                                    </Box>
                                );
                            } else if (tipo === 'html') {
                                return (
                                    <iframe
                                        src={urlPreview}
                                        style={{ width: '100%', height: '100%', border: 'none', minHeight: '600px' }}
                                        title="Vista previa HTML"
                                    />
                                );
                            } else if (tipo === 'text') {
                                return (
                                    <iframe
                                        src={urlPreview}
                                        style={{ width: '100%', height: '100%', border: 'none', minHeight: '600px' }}
                                        title="Vista previa texto"
                                    />
                                );
                            } else {
                                return (
                                    <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                                        <Typography>
                                            No se puede previsualizar este tipo de archivo. Puedes descargarlo usando el botón de abajo.
                                        </Typography>
                                    </Box>
                                );
                            }
                        })()
                    ) : null}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => descargarArchivo(documentoPreview.id, obtenerNombreArchivo(documentoPreview.ruta))}
                        disabled={!documentoPreview}
                        variant="contained"
                        sx={{ backgroundColor: '#336385', '&:hover': { backgroundColor: '#1f4b72' } }}
                    >
                        Descargar
                    </Button>
                    <Button onClick={cerrarModalPreview} color="error">Cerrar</Button>
                </DialogActions>
            </Dialog>

            {/* Menú desplegable de acciones */}
            <Menu
                anchorEl={anchorElAcciones}
                open={Boolean(anchorElAcciones)}
                onClose={handleCerrarMenuAcciones}
            >
                <MenuItem onClick={handleEditarDesdeMenu}>
                    <EditIcon fontSize="small" sx={{ mr: 1 }} />
                    Editar Permisos
                </MenuItem>
                <MenuItem onClick={handleEliminarDesdeMenu} sx={{ color: 'error.main' }}>
                    <DeleteIcon fontSize="small" sx={{ mr: 1 }} />
                    Eliminar
                </MenuItem>
                <MenuItem onClick={() => descargarArchivo(documentoAccion.id, obtenerNombreArchivo(documentoAccion.ruta))}>
                    <DownloadIcon fontSize="small" sx={{ mr: 1 }} />
                    Descargar
                </MenuItem>
            </Menu>

            {/* Modal de confirmación de eliminación */}
            <Dialog
                open={modalConfirmarEliminar}
                onClose={handleCancelarEliminar}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ backgroundColor: 'error.main', color: 'white' }}>Confirmar Eliminación</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ paddingTop: 2 }}>
                        {documentosAEliminar.length === 1
                            ? '¿Estás seguro de que quieres eliminar este documento? Esta acción no se puede deshacer.'
                            : `¿Estás seguro de que quieres eliminar ${documentosAEliminar.length} documentos? Esta acción no se puede deshacer.`
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelarEliminar} disabled={eliminandoDocumentos} color="error">
                        Cancelar
                    </Button>
                    <Button 
                        onClick={handleConfirmarEliminar} 
                        color="error" 
                        variant="contained"
                        disabled={eliminandoDocumentos}
                    >
                        {eliminandoDocumentos ? <CircularProgress size={24} /> : 'Eliminar'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

const CabeceraForm = styled.div`
    margin: 5% 0% 1% 0%;
    padding: 0 2%;
`;

const ContainerPrincipal = styled.div`
    padding: 0 2%;
    margin-bottom: 2%;
`;

export default GestorDocumentos;
